function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.073 5.55a3.525 3.525 0 100 7.048 3.525 3.525 0 000-7.049zM7.05 9.073a2.025 2.025 0 114.049 0 2.025 2.025 0 01-4.05 0z",
  fill: "#313D53"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.074 0C4.75 0 .25 2.827.25 8c0 3.86 1.657 6.847 3.546 8.86.944 1.005 1.953 1.776 2.86 2.3.877.506 1.754.837 2.418.837.666 0 1.534-.332 2.398-.84.895-.524 1.886-1.297 2.81-2.303 1.853-2.014 3.468-5 3.468-8.854 0-5.158-4.334-8-8.676-8zM1.75 8c0-4.075 3.531-6.5 7.324-6.5 3.774 0 7.176 2.41 7.176 6.5 0 3.408-1.423 6.046-3.072 7.84-.825.897-1.7 1.575-2.465 2.024-.796.467-1.38.633-1.64.633s-.855-.167-1.666-.636c-.78-.45-1.673-1.129-2.517-2.027C3.205 14.038 1.75 11.402 1.75 8z",
  fill: "#313D53"
})));